import { IContentFormData } from './types'

const DRAFT_KEY = 'task_creation_v2_draft'

export interface IDraftData extends IContentFormData {
  savedAt: number
  /** Serialised FormStepContext formData — restored as FormStepProvider initialData */
  settingsData?: Record<string, unknown>
  /** Which page step (0 = content, 1 = settings) the user was on when draft was saved */
  pageStep?: 0 | 1
}

/** Save draft — skips if form is completely empty */
export const saveDraft = (data: Omit<IDraftData, 'savedAt'>): void => {
  try {
    if (!data.title?.trim() && !data.categories?.length) return
    const payload: IDraftData = { ...data, savedAt: Date.now() }
    localStorage.setItem(DRAFT_KEY, JSON.stringify(payload))
  } catch {
    // localStorage unavailable or quota exceeded — silently ignore
  }
}

/** Returns the saved draft or null if none exists */
export const loadDraft = (): IDraftData | null => {
  try {
    const raw = localStorage.getItem(DRAFT_KEY)
    if (!raw) return null
    return JSON.parse(raw) as IDraftData
  } catch {
    return null
  }
}

/** Remove draft (call on successful submit or cancel) */
export const clearDraft = (): void => {
  localStorage.removeItem(DRAFT_KEY)
}

/** Human-readable "X min ago" label for the restored banner */
export const formatDraftAge = (savedAt: number): string => {
  const mins = Math.floor((Date.now() - savedAt) / 60_000)

  if (mins < 1) return 'just now'
  if (mins < 60) return `${mins} min ago`

  const hours = Math.floor(mins / 60)

  if (hours < 24) return `${hours}h ago`
  return `${Math.floor(hours / 24)}d ago`
}
